import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import Junior from '@/pages/Junior'
import About from '@/pages/About'
import Download from '@/pages/Download'
import DiscoveryIndex from '@/pages/Discovery/Index'
import ClassDetail from '@/pages/Discovery/ClassDetail'
import ArticleDetail from '@/pages/Discovery/ArticleDetail'
import ListenDetail from '@/pages/Discovery/ListenDetail'
import Teacher from '@/pages/Teacher'
import Teachercz from '@/pages/Teachercz'
import Messages from '@/pages/Messages'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Teacher',
      component: Teacher
    },
    {
      path: '/student',
      name: 'Index',
      component: Index
    },
    {
      path: '/download',
      name: 'Download',
      component: Download
    },
    {
      path: '/junior',
      name: 'Junior',
      component: Junior
    },
    {
      path: '/teachercz',
      name: 'Teachercz',
      component: Teachercz
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/discovery',
      name: 'Discovery',
      component: DiscoveryIndex
    },
    {
      path: '/discovery/class/:id',
      name: 'ClassDetail',
      component: ClassDetail
    },
    {
      path: '/discovery/article/:id',
      name: 'ArticleDetail',
      component: ArticleDetail
    },
    {
      path: '/discovery/listen/:id',
      name: 'ListenDetail',
      component: ListenDetail
    },
    {
      path: '/message',
      name: 'Message',
      component: Messages
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js